class  ArrayHelper
{
    forEach(arr:Array<any>, fn:any){
        if (!arr.length || !fn) return
        let i = -1
        let len = arr.length
        while (++i < len) {
          let item = arr[i]
          fn(item, i, arr)
        }
      }
      
      /**
       * @param {Array} arr1
       * @param {Array} arr2
       * @description 得到两个数组的交集, 两个数组的元素为数值或字符串
       */
       getIntersection(arr1:Array<any>, arr2:Array<any>) {
        let len = Math.min(arr1.length, arr2.length)
        let i = -1
        let res = []
        while (++i < len) {
          const item = arr2[i]
          if (arr1.indexOf(item) > -1) res.push(item)
        }
        return res
      }
      
      /**
       * @param {Array} arr1
       * @param {Array} arr2
       * @description 得到两个数组的并集, 两个数组的元素为数值或字符串
       */
      getUnion(arr1:Array<any>, arr2:Array<any>) {
        return Array.from(new Set([...arr1, ...arr2]))
      }
      
      /**
       * @param {Array} target 目标数组
       * @param {Array} arr 需要查询的数组
       * @description 判断要查询的数组是否至少有一个元素包含在目标数组中
       */
      hasOneOf(targetArr:Array<any>, arr:Array<any>){
        return targetArr.some(_ => arr.indexOf(_) > -1)
      }
      
      /**
       * @param {String|Number} value 要验证的字符串或数值
       * @param {*} validList 用来验证的列表
       */
      oneOf (value:String|Number, validList:any) {
        for (let i = 0; i < validList.length; i++) {
          if (value === validList[i]) {
            return true
          }
        }
        return false
      }
      
    
      /**
       * 判断一个对象是否存在key，如果传入第二个参数key，则是判断这个obj对象是否存在key这个属性
       * 如果没有传入key这个参数，则判断obj对象是否有键值对
       */
     hasKey(obj, key){
        if (key) return key in obj
        else {
          let keysArr = Object.keys(obj)
          return keysArr.length
        }
      }
      
      /**
       * @param {*} obj1 对象
       * @param {*} obj2 对象
       * @description 判断两个对象是否相等，这两个对象的值只能是数字或字符串
       */
      objEqual(obj1, obj2) {
        const keysArr1 = Object.keys(obj1)
        const keysArr2 = Object.keys(obj2)
        if (keysArr1.length !== keysArr2.length) return false
        else if (keysArr1.length === 0 && keysArr2.length === 0) return true
        /* eslint-disable-next-line */
        else return !keysArr1.some(key => obj1[key] != obj2[key])
      }
}
export const arrayHelper = new ArrayHelper()
  